import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import figure2 from "../../../../assets/images/weighing/actions/descargar.png"; 
import figure3 from "../../../../assets/images/weighing/actions/compartir.png"; 
import figure4 from "../../../../assets/images/weighing/actions/escanear.png"; 

import MenuAdmin from "../../../../components/layout/menu";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

export default function TicketGenerated() {
    const location = useLocation();
    const navigate = useNavigate();
    const events = location.state?.events || [];
    console.log("events: ", events);

    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    
    const handleScanClick = () => {
        navigate("/");
    };

    const formatDate = (dateString) => {
        const options = { 
            day: '2-digit', 
            month: 'long', 
            hour: 'numeric', 
            minute: 'numeric', 
            hour12: true // Asegura que se use el formato de 12 horas
        };
        const date = new Date(dateString);
        return date.toLocaleString('es-ES', options).replace(',', ''); // Reemplaza la coma para un mejor formato
    };

    const handleDownload = () => {
        const doc = new jsPDF();
        const pdfContent = document.getElementById("pdf");
    
        if (window.innerWidth > 1000) {
            doc.html(pdfContent, {
                callback: function (doc) {
                    doc.save("ticket_pesaje.pdf"); 
                },
                x: 10,
                y: 10,
                width: 180,
                windowWidth:  window.innerWidth, 
            });
        } else {
            // Si la pantalla es más pequeña, usar una vista más simple
            doc.html(pdfContent, {
                callback: function (doc) {
                    doc.save("ticket_pesaje.pdf");
                },
                x: 10,
                y: 10,
                width: 180,
            });
        }
    };

    return(
        <div className="flex w-full h-screen">
          <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
            <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] " : "ml-0"} w-[100%]`}>
               
          <div className="flex justify-between min-h-screen flex-col pt-24 md:pt-44  lg:pt-40 xl:pt-40   px-[5%] bg-white py-16 lg:px-[20%]">
              <div className="flex flex-col">
                <h1 className="text-[32px] text-blue font-itcbold text-center pb-8">TICKETS</h1>
                {events.length > 0  ? (
                    events.map ((event, index) => (
                      <button 
                        key={event.id}
                        onClick={() => navigate("/detalle-ticket", { state: { eventData: event } })}
                        className="flex justify-between border-b-[1px] border-b-gray pb-3 mb-3">
                        <p className="md:text-2xl text-[18px] text-blue font-itcmedium">Ticket de pesaje #{index+1}</p>
                        <p className="text-gray font-itcbook text-base md:text-[20px]"> {formatDate(event.createdAt)}</p>
                      </button>
                    ))
                ) : (
                    <p className="text-center text-gray-500">No hay eventos registrados.</p>

                )}

              </div>

              <div className="flex flex-col">
                <div className="grid justify-between w-full px-[5%] gap-4 pt-16 justify-items lg:ml-0 sm:flex md:flex sm:w-full sm:grid-cols-none">
                      <button onClick={handleDownload}
                          className="flex gap-4 sm:h-[64px] h-[46px] text-lg text-center text-[#77A042] font-itcdemi">
                          <img
                              src={figure2}
                              alt="Descargar"
                              className="w-[32px] h-[27.8px]" 
                          />
                          Descargar
                      </button>
                
                      <button className="flex gap-4 sm:px-24 px-[35px] sm:h-[64px] h-[46px] text-lg text-center text-[#77A042] font-itcdemi">
                          <img
                              src={figure3}
                              alt="Compartir"
                              className="w-[22px] h-[26px]" 
                          />
                          Compartir
                      </button>
                
                      <div className="col-span-2 ml-28 sm:ml-0 md:ml-0">
                          <button onClick={handleScanClick}
                              className="flex gap-4 sm:h-[64px] h-[46px] text-lg text-center text-[#77A042] font-itcdemi">
                              <img
                                  src={figure4}
                                  alt="Escanear"
                                  className="w-[28px] h-[28px]" 
                              />
                              Escanear
                          </button> 
                      </div>                
                  </div>
                
                  <div className="flex w-full justify-center pt-3 gap-8 md:justify-between px-[5%] sm:gap-16">
                    <button className=" inline-block  h-[64px] w-[310px]  text-lg text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                      Imprimir
                    </button> 
                
                    <button onClick={handleScanClick}
                    className=" inline-block h-[64px] w-[310px] text-lg text-center leading-tight text-white bg-green rounded-2xl font-itcdemi">
                        Nuevo pesaje
                    </button>   
                </div>
              </div>  
              </div>
          </div>
        </div>
    );
}